/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__table_head_actions = /** @type {(inputs: {}) => string} */ () => {
	return `Aktionen (Route löschen oder ansehen)`
};

const en_bookmark__table_head_actions = /** @type {(inputs: {}) => string} */ () => {
	return `Actions (Delete or view route)`
};

const es_bookmark__table_head_actions = /** @type {(inputs: {}) => string} */ () => {
	return `Acciones (eliminar o ver ruta)`
};

const fr_bookmark__table_head_actions = /** @type {(inputs: {}) => string} */ () => {
	return `Actions (Effacer ou voir l'itinéraire)`
};

const it_bookmark__table_head_actions = /** @type {(inputs: {}) => string} */ () => {
	return `Azioni (eliminare o visualizzare il percorso)`
};

const nl_bookmark__table_head_actions = /** @type {(inputs: {}) => string} */ () => {
	return `Acties (route verwijderen of bekijken)`
};

const pt_bookmark__table_head_actions = /** @type {(inputs: {}) => string} */ () => {
	return `Acções (apagar ou visualizar a rota)`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_actions = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__table_head_actions(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__table_head_actions", locale)
	if (locale === "de") return de_bookmark__table_head_actions(inputs)
	if (locale === "en") return en_bookmark__table_head_actions(inputs)
	if (locale === "es") return es_bookmark__table_head_actions(inputs)
	if (locale === "fr") return fr_bookmark__table_head_actions(inputs)
	if (locale === "it") return it_bookmark__table_head_actions(inputs)
	if (locale === "nl") return nl_bookmark__table_head_actions(inputs)
	return pt_bookmark__table_head_actions(inputs)
};